export interface DownFlingGesture {
  deltaX: number;
  deltaY: number;
  durationMs: number;
  hadMultiplePointers: boolean;
}

const MIN_DOWN_DISTANCE = 96;
const MAX_FLING_DURATION_MS = 450;
const MIN_DOWN_VELOCITY = 0.65;
const DIRECTION_BIAS = 1.35;

export function shouldCloseOnDownFling(gesture: DownFlingGesture): boolean {
  if (gesture.hadMultiplePointers || gesture.deltaY < MIN_DOWN_DISTANCE) return false;
  if (gesture.durationMs <= 0 || gesture.durationMs > MAX_FLING_DURATION_MS) return false;
  if (gesture.deltaY < Math.abs(gesture.deltaX) * DIRECTION_BIAS) return false;
  return gesture.deltaY / gesture.durationMs >= MIN_DOWN_VELOCITY;
}
